import masterData from "../masterData";

export const getCampaignPrice = room => {
  let price = room.price;
  const campaignId = room.primaryCampaign || room.campaigns && room.campaigns[0];
  const campaign = masterData.campaign.byId[campaignId];
  if (!campaign) {
    // noop
  } else if (campaign.type === 1) {
    price -= campaign.typeValue;
  } else if (campaign.type === 2) {
    price *= campaign.typeValue;
  } else if (campaign.type === 3) {
    price = campaign.typeValue;
  }
  return price === room.price ? null : price;
};



// WEBPACK FOOTER //
// ./lib/masterUtil/getCampaignPrice.js